"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableHead = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var TableSortLabel_1 = __importDefault(require("@material-ui/core/TableSortLabel"));
exports.DataTableHead = function (_a) {
    var columns = _a.columns, onSelectAllClick = _a.onSelectAllClick, doSort = _a.doSort, sortable = _a.sortable, checkable = _a.checkable;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.default.useState(false), allSelected = _b[0], setAllSelected = _b[1];
    var sortDescendingInitial = columns.map(function () { return false; });
    var _c = react_1.default.useState(sortDescendingInitial), sortDescending = _c[0], setSortDescending = _c[1];
    var clicked = function () {
        onSelectAllClick(!allSelected);
        setAllSelected(!allSelected);
    };
    var sortBy = function (id) {
        doSort(id, sortDescending[id] ? 'desc' : 'asc');
        sortDescending[id] = !sortDescending[id];
        setSortDescending(sortDescending);
    };
    return (react_1.default.createElement(TableHead_1.default, null,
        react_1.default.createElement(TableRow_1.default, null,
            checkable && (react_1.default.createElement(TableCell_1.default, { padding: "checkbox" },
                react_1.default.createElement(Checkbox_1.default, { disableRipple: true, onClick: clicked, checked: allSelected, inputProps: { 'aria-label': 'select all' } }))),
            columns.map(function (col, i) {
                var cellContent = sortable ? (react_1.default.createElement(TableSortLabel_1.default, { direction: sortDescending[i] ? 'desc' : 'asc', onClick: function () { return sortBy(i); } },
                    react_1.default.createElement("b", null, t(col.label)))) : (react_1.default.createElement("b", null, t(col.label)));
                return (react_1.default.createElement(TableCell_1.default, { key: col.label, align: col.alignment === 'right' ? 'right' : 'left' }, cellContent));
            }),
            react_1.default.createElement(TableCell_1.default, { align: "right" }))));
};
exports.default = exports.DataTableHead;
//# sourceMappingURL=DataTableHead.js.map